import { render, staticRenderFns } from "./Address-Lines.vue?vue&type=template&id=036ac1c0&"
import script from "./Address-Lines.vue?vue&type=script&lang=js&"
export * from "./Address-Lines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports